// import { useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";

// import { authService } from "./services/authService";
// import {
//   AuthPrincipal,
//   UserBasicData,
//   useUserContext,
// } from "../context/UserContext";


// // ============================================================
// // TOKEN PAYLOAD
// // ============================================================

// export interface AccessTokenPayload {
//   user_id?: string;
//   sub?: string;

//   name?: string;
//   email?: string;

//   provider?: string;
//   is_oauth?: string;
//   type?: string;

//   iat: number;
//   exp: number;
// }


// // ============================================================
// // AUTH CALLBACK
// // ============================================================

// export default function AuthCallback() {
//   const navigate = useNavigate();

//   const { initializeSession } = useUserContext();

//   /**
//    * React StrictMode runs effects twice in development.
//    *
//    * This ref prevents the authentication callback from being
//    * processed twice.
//    */
//   const startedRef = useRef(false);


//   useEffect(() => {
//     if (startedRef.current) {
//       console.log(
//         "⏭️ AUTH CALLBACK: Already processed; skipping duplicate effect"
//       );

//       return;
//     }

//     startedRef.current = true;


//     const handleAuthCallback = async () => {
//       console.log("🚀 AUTH CALLBACK START");

//       try {
//         // ====================================================
//         // 1. Read callback parameters
//         // ====================================================

//         const params = new URLSearchParams(
//           window.location.search
//         );

//         const accessToken =
//           params.get("access_token") ??
//           params.get("token");

//         const refreshToken =
//           params.get("refresh_token");


//         console.log(
//           "🔐 AUTH CALLBACK: Token params",
//           {
//             hasAccessToken: Boolean(accessToken),
//             hasRefreshToken: Boolean(refreshToken),
//           }
//         );


//         if (!accessToken) {
//           console.error(
//             "❌ AUTH CALLBACK: No access token"
//           );

//           navigate("/", {
//             replace: true,
//           });

//           return;
//         }


//         console.log(
//           "🔑 AUTH CALLBACK: Access token received"
//         );


//         // ====================================================
//         // 2. Decode access token
//         // ====================================================

//         const payload =
//           jwtDecode<AccessTokenPayload>(
//             accessToken
//           );


//         console.log(
//           "🧾 AUTH CALLBACK: Token payload",
//           payload
//         );


//         const authUserId =
//           payload.user_id ??
//           payload.sub;


//         if (!authUserId) {
//           throw new Error(
//             "Authentication token does not contain user_id/sub"
//           );
//         }


//         const principal: AuthPrincipal = {
//           auth_user_id:
//             Number(authUserId),

//           email:
//             payload.email ?? "",

//           name:
//             payload.name ?? null,
//         };


//         console.log(
//           "👤 AUTH CALLBACK: Principal resolved",
//           principal
//         );


//         // ====================================================
//         // 3. Persist tokens
//         // ====================================================

//         authService.setTokens(
//           accessToken,
//           refreshToken ?? ""
//         );


//         console.log(
//           "💾 AUTH CALLBACK: Tokens persisted"
//         );


//         // ====================================================
//         // 4. Persist minimal metadata
//         // ====================================================

//         localStorage.setItem(
//           "authUserId",
//           String(principal.auth_user_id)
//         );


//         if (principal.email) {
//           localStorage.setItem(
//             "authEmail",
//             principal.email
//           );
//         }


//         // ====================================================
//         // 5. Remove tokens from callback URL
//         //
//         // This prevents accidental re-processing if the
//         // callback component is rendered again.
//         // ====================================================

//         window.history.replaceState(
//           {},
//           document.title,
//           window.location.pathname
//         );


//         console.log(
//           "🧹 AUTH CALLBACK: Callback URL cleaned"
//         );


//         // ====================================================
//         // 6. Initialize authenticated session
//         // ====================================================

//         console.log(
//           "⏳ AUTH CALLBACK: Initializing UserContext..."
//         );


//         const basicData:
//           | UserBasicData
//           | null =
//           await initializeSession(
//             accessToken
//           );


//         if (!basicData) {
//           throw new Error(
//             "Unable to initialize user basic data"
//           );
//         }


//         console.log(
//           "✅ AUTH CALLBACK: UserContext READY",
//           {
//             id:
//               basicData.id,

//             authUserId:
//               basicData.auth_user_id,

//             email:
//               basicData.email,

//             name:
//               basicData.name,

//             role:
//               basicData.role_name,

//             userType:
//               basicData.user_type,

//             isGuest:
//               basicData.is_guest,
//           }
//         );


//         // ====================================================
//         // 7. Determine destination
//         // ====================================================

//         const isAdmin =
//           basicData.role_name
//             ?.trim()
//             .toUpperCase() === "ADMIN";


//         const destination =
//           isAdmin
//             ? "/admin"
//             : "/home";


//         console.log(
//           "🚦 AUTH CALLBACK: Navigation decision",
//           {
//             isAdmin,

//             role:
//               basicData.role_name,

//             isGuest:
//               basicData.is_guest,

//             destination,
//           }
//         );


//         // ====================================================
//         // 8. Navigate
//         //
//         // IMPORTANT:
//         // Do NOT check a cancelled flag here.
//         // The first StrictMode effect is intentionally allowed
//         // to complete.
//         // ====================================================

//         console.log(
//           `➡️ AUTH CALLBACK: Navigating to ${destination}`
//         );


//         navigate(
//           destination,
//           {
//             replace: true,
//           }
//         );


//         console.log(
//           "🏁 AUTH CALLBACK COMPLETE"
//         );

//       } catch (error) {
//         console.error(
//           "❌ AUTH CALLBACK FAILED",
//           error
//         );


//         navigate("/", {
//           replace: true,
//         });
//       }
//     };


//     void handleAuthCallback();

//   }, [
//     navigate,
//     initializeSession,
//   ]);


//   return (
//     <div className="flex min-h-[40vh] items-center justify-center">
//       <div className="text-center">
//         <p className="text-sm text-gray-500">
//           Signing you in...
//         </p>
//       </div>
//     </div>
//   );
// }

import {
  useEffect,
  useRef,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import {
  jwtDecode,
} from "jwt-decode";

import {
  authService,
} from "./services/authService";

import {
  AuthPrincipal,
  useUserContext,
} from "../context/UserContext";


// ============================================================
// TOKEN PAYLOAD
// ============================================================

export interface AccessTokenPayload {
  user_id?: string;
  sub?: string;

  name?: string;
  email?: string;

  provider?: string;
  is_oauth?: string;
  type?: string;

  iat: number;
  exp: number;
}


// ============================================================
// AUTH CALLBACK
// ============================================================

export default function AuthCallback() {

  const navigate =
    useNavigate();


  const {
    establishSession,
  } =
    useUserContext();


  /**
   * React StrictMode can execute effects twice in development.
   *
   * This prevents the same callback transaction from being
   * processed twice.
   */
  const processedRef =
    useRef(false);


  useEffect(() => {

    if (
      processedRef.current
    ) {

      console.log(
        "⏭️ AUTH CALLBACK: duplicate effect ignored"
      );

      return;
    }


    processedRef.current = true;


    const handleAuthCallback =
      async () => {

        console.log(
          "🚀 AUTH CALLBACK START"
        );


        try {

          // ==================================================
          // 1. READ AUTH RESPONSE
          // ==================================================

          const params =
            new URLSearchParams(
              window.location.search
            );


          const accessToken =
            params.get(
              "access_token"
            ) ||
            params.get(
              "token"
            );


          const refreshToken =
            params.get(
              "refresh_token"
            );


          console.log(
            "🔐 AUTH CALLBACK: Token params",
            {
              hasAccessToken:
                Boolean(accessToken),

              hasRefreshToken:
                Boolean(refreshToken),
            }
          );


          if (
            !accessToken
          ) {

            throw new Error(
              "Authentication callback did not contain an access token"
            );
          }


          // ==================================================
          // 2. DECODE TOKEN
          // ==================================================

          console.log(
            "🔑 AUTH CALLBACK: Access token received"
          );


          const payload =
            jwtDecode<AccessTokenPayload>(
              accessToken
            );


          console.log(
            "🧾 AUTH CALLBACK: Token payload",
            payload
          );


          const authUserId =
            payload.user_id ||
            payload.sub;


          if (
            !authUserId
          ) {

            throw new Error(
              "Authentication token does not contain user_id/sub"
            );
          }


          const principal:
            AuthPrincipal = {

              auth_user_id:
                Number(
                  authUserId
                ),

              email:
                payload.email ??
                "",

              name:
                payload.name ??
                null,
            };


          console.log(
            "👤 AUTH CALLBACK: Principal resolved",
            principal
          );


          // ==================================================
          // 3. PERSIST TOKENS
          // ==================================================

          authService.setTokens(
            accessToken,
            refreshToken ??
            ""
          );


          console.log(
            "💾 AUTH CALLBACK: Tokens persisted"
          );


          // ==================================================
          // 4. OPTIONAL METADATA
          // ==================================================

          localStorage.setItem(
            "authUserId",
            String(
              principal.auth_user_id
            )
          );


          if (
            principal.email
          ) {

            localStorage.setItem(
              "authEmail",
              principal.email
            );
          }


          // ==================================================
          // 5. ESTABLISH APPLICATION SESSION
          // ==================================================

          console.log(
            "⏳ AUTH CALLBACK: Establishing application session..."
          );


          /**
           * IMPORTANT:
           *
           * establishSession:
           *
           *   GET /me/basic
           *        ↓
           *   services
           *        ↓
           *   populate UserProvider
           *        ↓
           *   return exact session
           *
           * There is no second initialization here.
           */
          const session =
            await establishSession(
              accessToken
            );


          if (
            !session
          ) {

            throw new Error(
              "Unable to establish authenticated session"
            );
          }


          // ==================================================
          // 6. SESSION READY
          // ==================================================

          const {
            basicData,
          } =
            session;


          console.log(
            "✅ AUTH CALLBACK: Session READY",
            {
              id:
                basicData.id,

              authUserId:
                basicData.auth_user_id,

              email:
                basicData.email,

              name:
                basicData.name,

              role:
                basicData.role_name,

              userType:
                basicData.user_type,

              isGuest:
                basicData.is_guest,
            }
          );


          // ==================================================
          // 7. DETERMINE DESTINATION
          // ==================================================

          const isAdmin =
            basicData.role_name
              ?.trim()
              .toUpperCase() ===
            "ADMIN";


          const destination =
            isAdmin
              ? "/admin"
              : "/home";


          console.log(
            "🚦 AUTH CALLBACK: Navigation decision",
            {
              isAdmin,

              role:
                basicData.role_name,

              isGuest:
                basicData.is_guest,

              destination,
            }
          );


          // ==================================================
          // 8. NAVIGATE
          // ==================================================

          console.log(
            `➡️ AUTH CALLBACK: Navigating to ${destination}`
          );


          navigate(
            destination,
            {
              replace: true,
            }
          );


          console.log(
            "🏁 AUTH CALLBACK COMPLETE"
          );

        } catch (
          error
        ) {

          console.error(
            "❌ AUTH CALLBACK FAILED",
            error
          );


          // -----------------------------------------------
          // Do not leave an invalid authentication state.
          // -----------------------------------------------

          authService.clearTokens();

          localStorage.removeItem(
            "authUserId"
          );

          localStorage.removeItem(
            "authEmail"
          );


          navigate(
            "/",
            {
              replace: true,
            }
          );
        }
      };


    void handleAuthCallback();

  }, [
    navigate,
    establishSession,
  ]);


  // ==========================================================
  // UI
  // ==========================================================

  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <div className="text-center">

        <p className="text-sm text-gray-500">
          Signing you in...
        </p>

      </div>
    </div>
  );
}